export default __webpack_public_path__ + "static/media/profile-web-1.5c6e3bfc.jpg";